<template>
    <div class="casepop">
        <div class="caselist">
            <div class="item1" v-for="i,index in itemlist" :key="index">
                <div class="card_item1">
                    <div class="item_img">
                        <img :src="i.url" alt="">
                    </div>
                    <div class="item_rama">
                        <div class="card_name">{{ i.name }}</div>
                        <div class="card_ramadk">
                            <div v-for="j,index in i.type" :key="index" class="jie_item">
                                <div>{{ j }}</div>
                                <div v-if="index+1!==i.type.length" class="heng">|</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card_item2">{{ i.ramack }}</div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {onMounted, ref} from 'vue'


const itemlist = ref([
    {
        name:'抖音',
        url:process.env.VUE_APP_PIC_URL+'/alanNotes/tiktok.png',
        ramack:'一个看视频的软件',
        type:['短视频','直播']
    },
    {
        name:'抖音',
        url:process.env.VUE_APP_PIC_URL+'/alanNotes/tiktok.png',
        ramack:'一个看视频的软件',
        type:['短视频','直播']
    },
    {
        name:'抖音',
        url:process.env.VUE_APP_PIC_URL+'/alanNotes/tiktok.png',
        ramack:'一个看视频的软件',
        type:['短视频','直播']
    },
    {
        name:'抖音',
        url:process.env.VUE_APP_PIC_URL+'/alanNotes/tiktok.png',
        ramack:'一个看视频的软件',
        type:['短视频','直播']
    },
    {
        name:'抖音',
        url:process.env.VUE_APP_PIC_URL+'/alanNotes/tiktok.png',
        ramack:'一个看视频的软件',
        type:['短视频','直播']
    },
])
</script>

<style lang="scss" scoped>
div::-webkit-scrollbar{display:none}
.casepop{
    width: 22rem;
    height: 30rem;
    border-radius: 1rem;
    background: var(--aboutpop-bac);
    border:1px solid var(--carditem-item-border1);
    position: absolute;
    top: 5rem;
    right: 16rem;
    animation: popin .7s ease-in forwards;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 2;
    .caselist{
        width: 95%;
        height: 85%;
        border-radius: 1rem;
        overflow: scroll;
        display: flex;
        flex-direction: column;
        align-items: center;
        .item1{
            width: 90%;
            // height: 10rem;
            border-radius: 1rem;
            padding: .7rem 1.2rem;
            display: flex;
            flex-direction: column;
            border: 1px solid var(--carditem-item-border1);
            background: var(--carditem-item-bac);
            // margin: 1rem .5rem;
            margin: .5rem 0;
            transition: opacity .2s ease-in;
            cursor: pointer;
            .card_item1{
                flex:1;
                display: flex;
                margin: 1rem 0;
                .item_img{
                    width: 3rem;
                    height: 3rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: .85rem;
                    background: #f6f6f6;
                    img{
                        width: 2rem;
                        border-radius: 10px;
                    }
                }
                .item_rama{
                    margin-left: 1rem;
                    display: flex;
                    flex-direction: column;
                    .card_name{
                        flex:1;
                        display: flex;
                        align-items: center;
                        color:var(--carditem-item-name);
                    }
                    .card_ramadk{
                        flex:1;
                        display: flex;
                        align-items: center;
                        .jie_item{
                            display: flex;
                            color:#b0b0b0;
                            font-size: .8rem;
                        }
                        .heng{
                            color:#b0b0b0;
                            margin: 0 10px;
                        }

                    }
                }
            }
            .card_item2{
                flex:1;
                margin: .5rem 0;
                font-size: 13px;
                color:#b0b0b0;
            }
            }
        .item1:hover{
            background: var(--carditem-item-hover);
        }
    }
}
</style>